"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dialog = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _WarningRounded = _interopRequireDefault(require("@material-ui/icons/WarningRounded"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _styles = require("@material-ui/core/styles");

var _Button = require("../button/Button");

var _utils = require("../utils");

var _styles2 = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CustomTooltip = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.paper,
      width: 355,
      minHeight: 48,
      marginLeft: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      fontSize: 14
    }
  };
})(_Tooltip.default);

var Dialog = function Dialog(_ref) {
  var title = _ref.title,
      children = _ref.children,
      secondaryButton = _ref.secondaryButton,
      primaryButton = _ref.primaryButton,
      size = _ref.size,
      alert = _ref.alert,
      label = _ref.label,
      tooltipContent = _ref.tooltipContent,
      tooltip = _ref.tooltip,
      open = _ref.open,
      handleClose = _ref.handleClose,
      handleConfirm = _ref.handleConfirm,
      confirmWithoutCheck = _ref.confirmWithoutCheck,
      isDisabled = _ref.isDisabled,
      alertMessage = _ref.alertMessage,
      stepper = _ref.stepper,
      handleCheck = _ref.handleCheck,
      PaperProps = _ref.PaperProps;
  var classes = (0, _styles2.useStyles)();
  var alertClasses = (0, _styles2.alertStyles)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeStep = _useState4[0],
      setActiveStep = _useState4[1];

  var isFinished = activeStep >= stepper.length - 1;

  var handleBack = function handleBack() {
    return setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var handleNext = function handleNext() {
    return setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  if (alertMessage) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: "".concat(alertClasses.root),
      maxWidth: "lg",
      open: open,
      onExited: function onExited() {
        return setIsChecked(false);
      },
      alert: alert ? 1 : 0,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement(_WarningRounded.default, {
      className: alertClasses.warning,
      style: {
        fontSize: 64
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, children, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      className: alertClasses.checkBox,
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: isChecked,
        onChange: function onChange() {
          return setIsChecked(!isChecked);
        }
      }),
      label: label
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleClose
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: alertClasses.primaryButton,
      color: "primary",
      variant: "contained",
      onClick: isChecked ? handleConfirm : confirmWithoutCheck,
      isDisabled: isDisabled,
      disabled: !isChecked || isDisabled
    }, primaryButton)));
  }

  if (alert) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: "".concat(alertClasses.root),
      maxWidth: "lg",
      open: open,
      onExited: function onExited() {
        return setIsChecked(false);
      },
      tooltip: tooltip ? 1 : 0,
      alert: alert ? 1 : 0,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title, tooltip && /*#__PURE__*/_react.default.createElement(CustomTooltip, {
      TransitionComponent: _core.Zoom,
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
        style: {
          fontSize: 18
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: alertClasses.tooltipcontent
      }, tooltipContent)),
      placement: "right-end"
    }, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
      className: alertClasses.icon
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement(_WarningRounded.default, {
      className: alertClasses.warning,
      style: {
        fontSize: 64
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, children, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      className: alertClasses.checkBox,
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: isChecked,
        onChange: function onChange() {
          setIsChecked(!isChecked);
          handleCheck();
        }
      }),
      label: label
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleClose
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      isDisabled: isDisabled,
      disabled: !isChecked || isDisabled,
      className: alertClasses.primaryButton,
      color: "primary",
      variant: "contained",
      onClick: handleConfirm
    }, primaryButton)));
  }

  if (stepper && stepper.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: "".concat(alertClasses.root),
      maxWidth: "lg",
      open: open,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "close",
      onClick: handleClose,
      className: alertClasses.buttonClose
    }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, stepper[activeStep])), /*#__PURE__*/_react.default.createElement(_core.DialogActions, {
      style: {
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.MobileStepper, {
      variant: "dots",
      steps: stepper.length,
      position: "static",
      activeStep: activeStep,
      className: alertClasses.stepper
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.contentActions
    }, secondaryButton && activeStep > 0 && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleBack,
      disabled: activeStep === 0
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: alertClasses.primaryButtonStepper,
      color: "primary",
      variant: "text",
      onClick: !isFinished ? handleNext : handleClose,
      isDisabled: isDisabled
    }, !isFinished ? primaryButton : 'FECHAR'))));
  }

  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    className: classes.root,
    maxWidth: "lg",
    open: open,
    alert: alert ? 1 : 0,
    disableScrollLock: true,
    onClose: handleClose,
    PaperProps: PaperProps
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    size: size,
    style: {
      width: (0, _utils.checkSizeDialog)(size)
    },
    dividers: true
  }, children), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.secondaryButton,
    onClick: handleClose
  }, secondaryButton), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.primaryButton,
    onClick: handleConfirm,
    isDisabled: isDisabled,
    disabled: isDisabled,
    autoFocus: true
  }, primaryButton)));
};

exports.Dialog = Dialog;
Dialog.propTypes = {
  /**
   * Se 'True', o dialog é aberto
   */
  open: _propTypes.default.bool,

  /**
   * Escolhe o texto to título
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Texto do conteúdo
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Texto do botão primário
   */
  primaryButton: _propTypes.default.string.isRequired,

  /**
   * Seleciona o tamanho do dialog
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),

  /**
   * Se 'True', o component tem as características de alert
   */
  alert: _propTypes.default.bool,

  /**
   * Se 'True', habilita o tooltip
   */
  tooltip: _propTypes.default.bool,

  /**
   * Texto do botão secundário
   */
  secondaryButton: _propTypes.default.string,

  /**
   * Texto do checkbox
   */
  label: _propTypes.default.string,

  /**
   * Funcao a ser executada ao clicar no botao secundario
   */
  handleClose: _propTypes.default.func,

  /**
  /**
   * Funcao a ser executada ao clicar no checkbox
   */
  handleCheck: _propTypes.default.func,

  /**
   * Funcao a ser executada ao clicar no botao primario
   */
  handleConfirm: _propTypes.default.func.isRequired,

  /**
   * Funcao a ser executada ao clicar no botao primario sem o checkbox marcado (uso apenas no alertMessage)
   */
  confirmWithoutCheck: _propTypes.default.func.isRequired,

  /**
   * Texto presente no tooltip
   */
  tooltipContent: _propTypes.default.string,

  /**
   * Se 'true' o botão primário fica desabilitado
   */
  isDisabled: _propTypes.default.bool,

  /**
   * Se 'True', o component tem as características de alert porém pode ser clicado sem o checkbox
   */
  alertMessage: _propTypes.default.bool,

  /**
   * Se 'True', o component tem as características de stepper porém pode ser clicado sem o checkbox
   */
  stepper: _propTypes.default.arrayOf(_propTypes.default.node),

  /**
   * Objeto que define propriedades customizadas do elemento Paper.
   */
  PaperProps: _propTypes.default.shape()
};
Dialog.defaultProps = {
  open: false,
  secondaryButton: '',
  size: 'md',
  alert: false,
  alertMessage: false,
  label: 'aceito',
  handleClose: null,
  tooltipContent: 'Texto padrao do tooltip',
  tooltip: false,
  isDisabled: false,
  handleCheck: null,
  stepper: [],
  PaperProps: {}
};
var _default = Dialog;
exports.default = _default;